export class ActionBase {
	action: string;
}
